import React from 'react';
import { COMPANY_NAME } from '../../../utils';
import { useCompanyContext } from '../../../contexts/Company';
import { useLinesContext } from '../../../contexts/Lines';
import Stepper from '../../../components/Onboarding/BuildingBlocks/OnboardingWrapper';
import PageLayout from '../../../components/Onboarding/Product/Url';
import NoProduct from '../../../components/Onboarding/Product/NoProduct';

const HEADER = `Paste a link to the first product you'd like ${COMPANY_NAME} to fund.`;
const SUB_HEADER = `${COMPANY_NAME} Growth Plans infuse you with continuous capital to fund your supply chain. Next, you'll map your supply chain for this product.`;

export default function ProductUrl() {
  const { business } = useCompanyContext();
  const { products } = useLinesContext();

  return (
    <>
      <Stepper
        title={HEADER}
        subtitle={SUB_HEADER}
        hideContent={!(products && business)}
        headerWidth={900}
        contentWidth={900}
      >
        <PageLayout />
      </Stepper>
      {products && business && <NoProduct header="No product URL?" />}
    </>
  );
}
